import {
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  UseDisclosureReturn,
  VStack,
} from "@chakra-ui/react";
import { getAccountShortName } from "@syla/shared/types/models/AccountAccessBase";
import React from "react";
import { ConfirmActionModal } from "../../components/modals/ConfirmActionModal";
import { useUserContext } from "../../contexts/UserContext";
import { useMutationDeleteUser } from "../../store/useMutationDeleteUser";
import { useQueryGetAccounts } from "../../store/useQueryGetAccounts";

export function DeleteUserModal({
  disclosure,
}: {
  disclosure: UseDisclosureReturn;
}): React.ReactElement {
  const deleteUserMutation = useMutationDeleteUser();

  const { logout } = useUserContext();

  const queryGetAccounts = useQueryGetAccounts();

  const myAccounts =
    queryGetAccounts.data ?
      Object.values(queryGetAccounts.data.accounts).filter(
        (account) => account.onlyOwner,
      )
    : [];

  const isLoading = queryGetAccounts.isLoading || !queryGetAccounts.data;

  const deleteUser = async () => {
    await deleteUserMutation.mutateAsync();

    logout();
  };

  return (
    <ConfirmActionModal
      disclosure={disclosure}
      title="Delete user"
      confirmButtonText="Delete user"
      colorScheme="red"
      onConfirm={deleteUser}
    >
      {isLoading ?
        <Spinner />
      : <VStack spacing={6} align="stretch">
          <Text color="gray.600">
            This will delete your user profile and associated accounts,
            including transaction history, tax calculations, and purchases for
            your accounts. This action is irreversible.
          </Text>

          <Text color="gray.600">
            The following accounts will also be deleted:
          </Text>

          <TableContainer
            borderColor="gray.300"
            borderWidth="1px"
            borderRadius="md"
          >
            <Table>
              <Thead>
                <Tr>
                  <Th>Account</Th>
                </Tr>
              </Thead>

              <Tbody>
                {myAccounts.map((account) => (
                  <Tr key={account._id}>
                    <Td>{getAccountShortName(account)}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </VStack>
      }
    </ConfirmActionModal>
  );
}
